export default __webpack_public_path__ + "static/opencart-2949aa931c39916da7d3d7036f36753b.png";